import api from './api';
import { parseDisplayMentions } from './mentionEditor';

export const REACTIONS = ['like', 'love', 'smile', 'care'];

export const REACTION_META = {
  like:  { label: 'Mi piace',   accent: false },
  love:  { label: 'Adoro',      accent: true },
  smile: { label: 'Sorrido',    accent: false },
  care:  { label: 'Mi importa', accent: false },
};

export const MAX_PICTURES = 5;
export const MAX_LINKS = 3;
export const MAX_VIDEO_BYTES = 5 * 1024 * 1024;
export const MAX_TOTAL_PICTURE_BYTES = 15 * 1024 * 1024;

const userCache = new Map();

export function clearEffeisbuckUserCache() {
  userCache.clear();
}

export async function fetchUsersByIds(ids) {
  const missing = ids.filter((id) => !userCache.has(id));
  if (missing.length > 0) {
    try {
      const resp = await api.post('/effeisbuck/users/by-ids', { ids: missing });
      for (const u of resp.data || []) userCache.set(u.id, u);
    } catch (_) {}
  }
  const out = {};
  for (const id of ids) {
    if (userCache.has(id)) out[id] = userCache.get(id);
  }
  return out;
}

export function primeUserCache(users) {
  for (const u of users || []) {
    if (u?.id) userCache.set(u.id, u);
  }
}

export async function searchUsers(q) {
  if (!q || q.trim().length < 2) return [];
  const resp = await api.get(`/effeisbuck/users/search?q=${encodeURIComponent(q)}`);
  primeUserCache(resp.data || []);
  return resp.data || [];
}

export async function getFeed(page = 1, limit = 10) {
  return api.get(`/effeisbuck/feed?page=${page}&limit=${limit}`);
}

export async function getPost(id) {
  return api.get(`/effeisbuck/posts/${id}`);
}

export async function createPost(payload) {
  return api.post('/effeisbuck/posts', payload);
}

export async function deletePost(id) {
  return api.delete(`/effeisbuck/posts/${id}`);
}

export async function getComments(postId, page = 1, limit = 50) {
  return api.get(`/effeisbuck/posts/${postId}/comments?page=${page}&limit=${limit}`);
}

export async function addComment(postId, body) {
  return api.post(`/effeisbuck/posts/${postId}/comments`, { body });
}

export async function deleteComment(commentId) {
  return api.delete(`/effeisbuck/comments/${commentId}`);
}

export async function togglePostReaction(postId, kind) {
  return api.put(`/effeisbuck/posts/${postId}/reactions`, { kind });
}

export async function toggleCommentReaction(commentId, kind) {
  return api.put(`/effeisbuck/comments/${commentId}/reactions`, { kind });
}

export async function getMyProfile() {
  return api.get('/effeisbuck/profiles/me');
}

export async function updateMyProfile(data) {
  return api.patch('/effeisbuck/profiles/me', data);
}

export async function getProfile(userId) {
  return api.get(`/effeisbuck/profiles/${userId}`);
}

export function renderMentions(body) {
  return parseDisplayMentions(body);
}

/**
 * Formats a concise @handle from a user profile (email local-part or full name).
 * @param {object|null|undefined} user
 * @returns {string}
 */
export function formatUserHandle(user) {
  if (!user) return '@collega';
  if (user.email && user.email.includes('@')) {
    const local = user.email.split('@')[0].trim().toLowerCase();
    if (local) return `@${local}`;
  }
  const slug = [user.nome, user.cognome]
    .filter(Boolean)
    .join('.')
    .trim()
    .toLowerCase()
    .replace(/\s+/g, '.');
  return slug ? `@${slug}` : '@collega';
}

/**
 * Extracts a clean hostname from an external URL for link attachment cards.
 * @param {string} url
 * @returns {string}
 */
export function formatLinkDomain(url) {
  try {
    return new URL(url).hostname.replace(/^www\./i, '');
  } catch {
    return 'collegamento esterno';
  }
}
